import React from 'react';
import LoginScreen from '@screens/Auth/LoginScreen';
import ForgotPasswordScreen from '@screens/Auth/ForgotPasswordScreen';
import { ProfileTypes } from '@api/Users/User';
import { SidebarGroup } from '@navigation/sidebarGroups';

export interface RoutesInterface {
    path: string;
    name: string;
    element: React.FunctionComponent;
    /** Sin `icon` la ruta existe pero NO sale en el sidebar (pantallas de detalle). */
    icon?: React.FunctionComponent;
    /**
     * Grupo colapsable del sidebar. Sin grupo = renglón suelto arriba de todo.
     * El ORDEN de los grupos lo define `SIDEBAR_GROUPS` (@navigation/sidebarGroups),
     * no el orden en que aparecen aquí.
     */
    group?: SidebarGroup;
    /**
     * Perfiles que ven este renglón, cuando una MISMA lista de rutas sirve a
     * varios perfiles (`collaboratorRoutes` = gerente + colaborador). Ausente =
     * lo ven todos los perfiles que usan esa lista. Filtra la VISTA, no el
     * acceso: la ruta se monta igual (los permisos reales son de `hasPermission`).
     */
    profiles?: ProfileTypes[];
}

/**
 * Rutas PÚBLICAS (sin sesión). Todo lo que se agregue aquí es alcanzable por
 * cualquiera que teclee la URL.
 *
 * ⚠️ **Aquí vivía `/signup`, y se ELIMINÓ el 2026-08-30.** Era una pantalla
 * pública que creaba cuentas del panel —con su usuario de Firebase Auth y su
 * doc en `users`— sin invitación, sin aprobación y sin que nadie se enterara:
 * bastaba conocer la URL. No la enlazaba nada desde hacía tiempo, así que era
 * una puerta abierta sin puerta visible. Las altas de staff se hacen desde
 * **Usuarios** (`ListUsers`), que exige sesión y permisos.
 *
 * `UserCtrl.onCreateUser` se queda: lo usa esa pantalla.
 */
const authRoutes: RoutesInterface[] = [
    {
        element: LoginScreen,
        name: 'Login',
        path: '/'
    },
    {
        element: ForgotPasswordScreen,
        name: 'Forgot Password',
        path: '/forgotPassword'
    }
];

export default authRoutes;
